<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model="param.status"
        size="small"
        placeholder="请选择上架状态"
        clearable
        @change="getProductList"
      >
        <el-option
          v-for="item in activeType"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        @click="getProductList"
        style="margin-right: 10px"
        >搜索
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="vipOperation('add', tableData)"
        class="add-input"
        >+新增商品</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      height="700"
      v-loading="loading"
      element-loading-text="拼命加载中"
      @sort-change="handleSortChange"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="productName"
        label="名称"
        align="center"
        width="80"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cover"
        label="背景图"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.bgImg"
            :width="'180px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="newName"
        label="名称(新)"
        align="center"
        width="80"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.newName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="newBgImg"
        label="选中图"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.newBgImg"
            :width="'180px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="outBgImg"
        label="未选中图"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.outBgImg"
            :width="'180px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="id"
        align="center"
        width="120"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="duration"
        label="VIP天数"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.duration || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="vipLevel"
        label="会员等级"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.vipLevel || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="originalPrice"
        label="原价（金币）"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.originalPrice || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="discountedPrice"
        label="现优惠价（金币）"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.discountedPrice || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="赠送游戏金币"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.giveGameCoin || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="赠送ai脱衣次数"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.aiUndressCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="downloadCount"
        label="赠送下载次数"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.downloadCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="楼凤解锁次数"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.louFengUnlockTimes || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="楼凤折扣率(%)"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.louFengDiscount || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="楼凤预约折扣率(%)"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.loufengBookDiscount || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="楼凤折扣折扣天数"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.loufengBookDiscountDays || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="金币视频免费天数"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.goldVideoFreeDay || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goldVideoCouponNum"
        label="赠送观影券金币"
        align="center"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.goldVideoCouponNum || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goldVideoCouponCount"
        label="赠送观影券数量"
        align="center"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.goldVideoCouponCount || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payVidDiscount"
        label="支付视频折扣"
        align="center"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.payVidDiscount || "" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productType"
        label="产品类型"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.productType | productTypeList }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="position"
        label="产品位置"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.position || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="unitPriceDisplay"
        label="是否展示单价"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-switch v-model="scope.row.unitPriceDisplay" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="isAmountPay"
        label="金币购买"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isAmountPay" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="exclusiveOffer"
        label="专属特惠"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.exclusiveOffer || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="140">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-text="上架"
            inactive-text="下架"
            disabled
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="chanSplitMod"
        label="渠道分成模式"
        align="center"
        width="120"
        :formatter="showMod"
      ></el-table-column>
      <el-table-column
        prop="actionDesc"
        label="活动描述"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.actionDesc || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="vipCardDesc"
        label="vip卡描述"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.vipCardDesc || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="privilegeDesc"
        label="特权描述"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.privilegeDesc || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="showCountdownTime"
        label="新手卡倒计时(单位：小时)"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.showCountdownTime || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="备注"
        align="center"
        :show-overflow-tooltip="true"
        width="120px"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.desc || "暂无备注" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        width="80"
        sortable
      ></el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="privilege" label="特权" align="center" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.privilege && scope.row.privilege.length > 0">{{
            scope.row.privilege
          }}</span>
          <!-- <span v-if="scope.row.privilege&&scope.row.privilege.length>0">{{ scope.row.privilege.join(','||'') |privileges}}</span> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceTime"
        label="服务时间(单位:分钟)"
        align="center"
        width="100"
      >
        <template slot-scope="slot">
          <span>{{ slot.row.serviceTime || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="vipOperation('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeAdmin(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <vip-action
      ref="addVip"
      @handlerProductList="handlerProductList"
    ></vip-action>
  </div>
</template>
<script>
import API from "@/api";
import { sortEscape } from "@/utils/global";
import VipAction from "./components/vipAction";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      // VIP商品列表请求参数
      param: {
        key: "",
        value: "",
        status: undefined,
      },
      activeType: [
        { label: "上架", value: true },
        { label: "下架", value: false },
        { label: "全部", value: undefined },
      ],
    };
  },
  components: {
    VipAction,
  },
  created() {
    this.getProductList(this.param);
  },
  methods: {
    // 请求商品列表
    getProductList() {
      this.loading = true;
      API.getPruductList(this.param)
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getProductList(this.param);
    },
    // 删除管理员
    removeAdmin(row) {
      this.$confirm("您确定要删除当前商品吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.getDeleteSection({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getProductList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 回显分成模式
    showMod(row) {
      let str = "-";
      switch (row.chanSplitMod) {
        case 0:
          str = "不分成";
          break;
        case 1:
          str = "正常分成";
          break;
        default:
          break;
      }
      return str;
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.addVip.open(type, data);
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerProductList() {
      this.getProductList();
    },
  },
};
</script>

<style lang="scss">
.add-input {
  margin-left: 0 !important;
}
</style>
